(function () {
  'use strict';
  if (window.__ksShopToolsLoaded) return;
  window.__ksShopToolsLoaded = true;
  var cfgEl = document.getElementById('kst-config');
  if (!cfgEl || window.__kstReady) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  window.__kstReady = true;
 
  var I = {
    spin: '<svg class="kst-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 3a9 9 0 1 0 9 9"/></svg>',
    user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="3.6"/><path d="M4.5 20c.9-3.8 4-5.8 7.5-5.8s6.6 2 7.5 5.8"/></svg>'
  };
 
  var T = CFG.t || {};
  function tx(k, d) { var v = T[k]; return v == null || v === '' ? d : v; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  /* "[size] in stock": the text is escaped first, the values put in are
     already safe HTML */
  function fill(tpl, map) {
    return esc(tpl).replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }
  function plain(tpl, map) {
    return String(tpl).replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }
  function num(v) { return parseFloat(String(v).replace(/[^0-9.]/g, '')); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
 
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function KS() { return window.KSFinder || null; }
  function SV() { var k = KS(); return k && k.sizes && k.sizes.on ? k.sizes : null; }
  function track(name, data) { var k = KS(); if (k && typeof k.track === 'function') k.track(name, data); }
  function store(kind, key, value) {
    try {
      var s = kind === 'session' ? window.sessionStorage : window.localStorage;
      if (value === undefined) return s.getItem(key);
      if (value === null) s.removeItem(key); else s.setItem(key, value);
    } catch (e) {}
    return null;
  }
 
  function getJSON(url, opts) {
    opts = opts || {};
    var init = { method: opts.method || 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (opts.body) {
      init.headers['Content-Type'] = 'application/json';
      init.headers['X-Requested-With'] = 'XMLHttpRequest';
      init.body = JSON.stringify(opts.body);
    }
    return fetch(url, init).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) throw d;
        return d;
      });
    });
  }
 
  /* ---------- products, the same shape from /products/x.js and
     /collections/x/products.json ---------- */
  function norm(p) {
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var variants = (p.variants || []).map(function (v) {
      var opts = v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
      var img = v.featured_image && (v.featured_image.src || v.featured_image.url);
      return { id: v.id, title: v.title, available: !!v.available, opts: opts, img: img || '' };
    });
    var options = names.map(function (n, i) {
      var vals = [];
      var o = (p.options || [])[i];
      if (o && o.values) vals = o.values.slice();
      else variants.forEach(function (v) { if (vals.indexOf(v.opts[i]) < 0) vals.push(v.opts[i]); });
      return { name: n, values: vals };
    });
    var colorIdx = -1, sizeIdx = -1;
    names.forEach(function (n, i) {
      if (colorIdx < 0 && /colou?r/i.test(n)) colorIdx = i;
      if (sizeIdx < 0 && /size/i.test(n)) sizeIdx = i;
    });
    var tags = p.tags || [];
    if (typeof tags === 'string') tags = tags.split(',').map(function (t) { return t.trim(); });
    return {
      handle: p.handle, title: p.title, url: p.url || ('/products/' + p.handle),
      tags: tags, options: options, variants: variants, colorIdx: colorIdx, sizeIdx: sizeIdx
    };
  }
  function variantOf(p, sel) {
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i], ok = true;
      for (var j = 0; j < sel.length; j++) if (v.opts[j] !== sel[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  /* the shoe chart for this product, with what is in stock: in one color
     (the cart) or in any color (collection pages) */
  function chartOf(p, color) {
    var k = KS();
    if (!k || typeof k.build !== 'function' || p.sizeIdx < 0) return null;
    var avail = '|';
    p.variants.forEach(function (v) {
      if (!v.available) return;
      if (color != null && p.colorIdx > -1 && v.opts[p.colorIdx] !== color) return;
      avail += v.opts[p.sizeIdx] + '|';
    });
    return k.build({
      t: p.title, u: p.url, s: p.options[p.sizeIdx].values, a: avail, g: p.tags,
      c: p.colorIdx > -1 ? p.options[p.colorIdx].values : []
    });
  }
 
  var PROD = {};
  function product(handle) {
    if (!PROD[handle]) {
      PROD[handle] = getJSON(ROOT + 'products/' + encodeURIComponent(handle) + '.js').then(norm, function (e) {
        delete PROD[handle];
        throw e;
      });
    }
    return PROD[handle];
  }
 
  /* =====================================================================
     CHANGE IN THE CART
     The color and the size of each cart item become small lists, right
     where the theme shows them ("Color: Blue", "Size US: 2.5"). Choosing
     another one swaps the item straight away, with the same quantity.
     ===================================================================== */
  if (CFG.cart) (function () {
    var CART = null, loading = null, scanT = null;
 
    function loadCart() {
      if (!loading) {
        loading = getJSON(ROOT + 'cart.js').then(function (c) { CART = c; loading = null; return c; },
          function (e) { loading = null; throw e; });
      }
      return loading;
    }
    function lineFor(key) {
      if (!CART || !CART.items) return null;
      for (var i = 0; i < CART.items.length; i++) if (CART.items[i].key === key) return CART.items[i];
      return null;
    }
    function variantById(p, id) {
      for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id) return p.variants[i];
      return null;
    }
 
    function scan(again) {
      var items = $$('.cart__item[data-key]');
      if (!items.length) return;
      var missing = items.some(function (it) { return !lineFor(it.getAttribute('data-key')); });
      if (missing && !again) {
        loadCart().then(function () { scan(true); }, function () {});
        return;
      }
      items.forEach(decorate);
    }
    function scanSoon() { clearTimeout(scanT); scanT = setTimeout(scan, 80); }
 
    /* the size that fits each saved size, in this color: { "4.5": ["Emma"] } */
    function fitsFor(p, cur) {
      var sv = SV(), k = KS(), out = {};
      if (!CFG.fit || !sv || !k || p.sizeIdx < 0) return out;
      var people = sv.list();
      if (!people.length) return out;
      var chart = chartOf(p, p.colorIdx > -1 ? cur.opts[p.colorIdx] : null);
      if (!chart) return out;
      people.forEach(function (who) {
        var r = k.sizeFor(chart, who.foot, { fit: who.fit, socks: who.socks });
        if (!r || !r.bestAny) return;
        p.options[p.sizeIdx].values.forEach(function (val) {
          if (num(val) === r.bestAny.us) (out[val] = out[val] || []).push(who.name);
        });
      });
      return out;
    }
 
    /* one list: every value of this option, the ones that cannot be
       chosen with the rest of the item greyed out */
    function selectHtml(p, cur, i, title) {
      var fits = i === p.sizeIdx ? fitsFor(p, cur) : {};
      var sizeTxt = '';
      if (p.sizeIdx > -1 && i !== p.sizeIdx) {
        sizeTxt = (/\bUS\b/.test(p.options[p.sizeIdx].name) ? 'US ' : '') + cur.opts[p.sizeIdx];
      }
      var opts = p.options[i].values.map(function (val) {
        var test = cur.opts.slice();
        test[i] = val;
        var v = variantOf(p, test);
        var on = val === cur.opts[i];
        var label = val, off = false;
        if (!on && !v) { label += ' · ' + tx('na', 'not made'); off = true; }
        else if (!on && !v.available) {
          label += ' · ' + (sizeTxt ? plain(tx('sold_in', 'sold out in [size]'), { size: sizeTxt }) : tx('sold_out', 'sold out'));
          off = true;
        } else if (fits[val]) {
          label += ' · ' + plain(tx('fits', 'fits [name]'), { name: fits[val].join(', ') });
        }
        return '<option value="' + esc(val) + '"' + (on ? ' selected' : '') + (off ? ' disabled' : '') + '>' + esc(label) + '</option>';
      }).join('');
      return '<select class="kst-sel" data-kst-i="' + i + '" aria-label="' +
        esc(plain(tx('aria', 'Change the [option] of [item]'), { option: p.options[i].name, item: title })) + '">' + opts + '</select>';
    }
 
    /* A list is as wide as its longest choice. Make it as wide as the
       one chosen, so "Size US: 2.5" stays a small pill. */
    function fitWidth(s) {
      var o = s.options[s.selectedIndex];
      if (!o) return;
      var cs = getComputedStyle(s);
      var m = document.createElement('span');
      m.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;white-space:pre;' +
        'font-family:' + cs.fontFamily + ';font-size:' + cs.fontSize + ';font-weight:' + cs.fontWeight +
        ';font-style:' + cs.fontStyle + ';letter-spacing:' + cs.letterSpacing;
      m.textContent = o.text;
      document.body.appendChild(m);
      var w = m.getBoundingClientRect().width;
      m.parentNode.removeChild(m);
      var extra = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) +
        (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.borderRightWidth) || 0);
      if (w > 0) s.style.width = Math.ceil(w + extra + 2) + 'px';
    }
 
    function decorate(it) {
      if (it.getAttribute('data-kst') === '1') return;
      var line = lineFor(it.getAttribute('data-key'));
      if (!line || line.product_has_only_default_variant || line.gift_card || !line.handle) return;
      var box = it.querySelector('.cart__item--variants');
      if (!box) return;
      it.setAttribute('data-kst', '1');
      product(line.handle).then(function (p) {
        if (!it.isConnected) return;
        var cur = variantById(p, line.variant_id);
        if (!cur) return;
        Array.prototype.forEach.call(box.children, function (row) {
          var lab = row.querySelector('span');
          if (!lab) return;
          /* "Color:" in the cart is the product's "Color" option */
          var name = lab.textContent.replace(/[:：]\s*$/, '').trim().toLowerCase(), i = -1;
          p.options.forEach(function (o, n) { if (i < 0 && o.name.toLowerCase() === name) i = n; });
          if (i < 0 || p.options[i].values.length < 2) return;
          while (lab.nextSibling) row.removeChild(lab.nextSibling);
          var w = document.createElement('span');
          w.className = 'kst-selw';
          w.innerHTML = selectHtml(p, cur, i, line.product_title);
          row.appendChild(document.createTextNode(' '));
          row.appendChild(w);
          row.classList.add('kst-row');
          fitWidth(w.firstChild);
        });
      }, function () {});
    }
 
    /* a line under the color and size: "Updating…" or what went wrong */
    function note(it, html) {
      var n = it.querySelector('.kst-note');
      if (!n) {
        var box = it.querySelector('.cart__item--variants');
        if (!box) return;
        n = document.createElement('p');
        n.className = 'kst-note';
        n.setAttribute('role', 'status');
        box.parentNode.insertBefore(n, box.nextSibling);
      }
      n.innerHTML = html;
    }
 
    /* the theme's own cart (drawer and cart page) builds itself again */
    function rebuild() {
      CART = null;
      document.dispatchEvent(new CustomEvent('cart:build'));
      loadCart().then(function (c) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
        scanSoon();
      }, function () {});
    }
 
    /* Shopify cannot change the variant of a cart item: add the new one,
       then take the old one out. If adding fails, nothing has changed. */
    function swap(it, line, p, cur, v) {
      it.classList.add('kst-busy');
      $$('.kst-sel', it).forEach(function (s) { s.disabled = true; });
      note(it, I.spin + '<span>' + esc(tx('busy', 'Updating…')) + '</span>');
      var added = false;
      getJSON(ROOT + 'cart/add.js', {
        method: 'POST',
        body: { items: [{ id: v.id, quantity: line.quantity, properties: line.properties || {} }] }
      }).then(function () {
        added = true;
        return getJSON(ROOT + 'cart/change.js', { method: 'POST', body: { id: line.key, quantity: 0 } });
      }).then(function (cart) {
        CART = cart;
        track('ks_cart_change', { product: p.title, from: cur.title, to: v.title });
        rebuild();
      }).catch(function (err) {
        var m = err && (err.description || err.message);
        it.classList.remove('kst-busy');
        $$('.kst-sel', it).forEach(function (s) {
          s.disabled = false;
          s.value = cur.opts[+s.getAttribute('data-kst-i')];
          fitWidth(s);
        });
        note(it, esc(typeof m === 'string' && m ? m : tx('error', 'Could not change it. Please try again.')));
        if (added) rebuild();
      });
    }
 
    document.addEventListener('change', function (e) {
      var s = e.target;
      if (!s || !s.classList || !s.classList.contains('kst-sel')) return;
      var it = s.closest('.cart__item[data-key]');
      var line = it && lineFor(it.getAttribute('data-key'));
      if (!line) return;
      product(line.handle).then(function (p) {
        var cur = variantById(p, line.variant_id);
        if (!cur) return;
        var i = +s.getAttribute('data-kst-i');
        var want = cur.opts.slice();
        want[i] = s.value;
        var v = variantOf(p, want);
        if (!v || !v.available || v.id === cur.id) { s.value = cur.opts[i]; return; }
        swap(it, line, p, cur, v);
      }, function () {});
    });
 
    /* the theme builds the cart again after every change: watch for it */
    var targets = $$('#CartDrawer, #CartPageForm, [data-location="cart-drawer"], [data-location="cart-page"]');
    if (!targets.length) targets = [document.body];
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var n = list[i].addedNodes;
          for (var j = 0; j < n.length; j++) {
            var el = n[j];
            /* our own lists and notes are not a new cart */
            if (el.nodeType !== 1 || (el.closest && el.closest('.kst-selw, .kst-note'))) continue;
            if (el.classList && (el.classList.contains('kst-selw') || el.classList.contains('kst-note'))) continue;
            scanSoon();
            return;
          }
        }
      });
      targets.forEach(function (el) { mo.observe(el, { childList: true, subtree: true }); });
    }
    document.addEventListener('cart:updated', scanSoon);
    document.addEventListener('ks:sizes', function () {
      /* saved sizes changed: draw the lists again for the new "fits" */
      $$('.cart__item[data-kst="1"]').forEach(function (it) { it.removeAttribute('data-kst'); });
      scanSoon();
    });
    document.addEventListener('ajaxProduct:added', function () { CART = null; setTimeout(function () { loadCart().then(function () { scanSoon(); }, function () {}); }, 250); });
    if ($$('.cart__item[data-key]').length) loadCart().then(function () { scan(true); }, function () {});
  })();
 
  /* =====================================================================
     PRICES IN THE SHOPPER'S CURRENCY
     The store's currency app (Nova / Booster currency converter) turns
     the prices into the shopper's currency when the page loads, but not
     when the theme draws the cart again (after Add to cart, a quantity
     change or a Change in the cart). Ask it to, each time a new cart is in.
     ===================================================================== */
  if (CFG.money) (function () {
    var t = null;
    function refresh() {
      var bc = window.baCurr;
      if (bc && typeof bc.refreshConversion === 'function') {
        try { bc.refreshConversion(); } catch (e) {}
      }
    }
    function soon() {
      clearTimeout(t);
      t = setTimeout(function () { refresh(); setTimeout(refresh, 800); }, 120);
    }
    var targets = $$('#CartDrawer, #CartPageForm, [data-location="cart-drawer"], [data-location="cart-page"]');
    if (!targets.length || !window.MutationObserver) return;
    /* only a new list of items counts; the app changing the prices
       themselves does not, so it cannot set itself off again */
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var n = list[i].addedNodes;
        for (var j = 0; j < n.length; j++) {
          var el = n[j];
          if (el.nodeType !== 1) continue;
          if ((el.matches && el.matches('.cart__items, .cart__item')) || (el.querySelector && el.querySelector('.cart__item'))) { soon(); return; }
        }
      }
    });
    targets.forEach(function (el) { mo.observe(el, { childList: true, subtree: true }); });
  })();
 
  /* =====================================================================
     SWIPE TO CLOSE (phones)
     The menu comes in from the left, so a swipe to the left closes it;
     the cart comes in from the right, so a swipe to the right closes it.
     The drawer follows the finger. Far enough or fast enough closes it,
     anything less springs back. Up and down still scrolls as before.
     ===================================================================== */
  if (CFG.swipeMenu || CFG.swipeCart) (function () {
    var ids = [];
    if (CFG.swipeMenu) ids.push('NavDrawer');
    if (CFG.swipeCart) ids.push('CartDrawer');
    var mq = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
    var g = null, stopClick = 0;
 
    function openX(d) {
      var t = getComputedStyle(d).transform;
      if (!t || t === 'none') return 0;
      var m = /matrix\(([^)]+)\)/.exec(t);
      return m ? parseFloat(m[1].split(',')[4]) || 0 : 0;
    }
    function move(d, x, anim) {
      d.style.transition = anim ? 'transform ' + anim : 'none';
      d.style.transform = 'translateX(' + x + 'px)';
    }
    function clear(d) {
      d.style.transition = '';
      d.style.transform = '';
    }
 
    function start(e) {
      g = null;
      if (!mq || !mq.matches || !e.touches || e.touches.length !== 1) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var d = t.closest('.drawer.drawer--is-open');
      if (!d || ids.indexOf(d.id) < 0) return;
      if (t.closest('input, select, textarea')) return;
      var p = e.touches[0];
      g = {
        d: d, x: p.clientX, y: p.clientY, on: false,
        dir: d.classList.contains('drawer--left') ? -1 : 1,
        base: openX(d), w: d.offsetWidth || 320,
        dx: 0, lx: p.clientX, lt: Date.now(), v: 0
      };
    }
 
    function drag(e) {
      if (!g || !e.touches || !e.touches.length) return;
      var p = e.touches[0], dx = p.clientX - g.x, dy = p.clientY - g.y;
      if (!g.on) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        /* up and down, or toward the open side: a normal scroll */
        if (Math.abs(dy) > Math.abs(dx) || dx * g.dir <= 0) { g = null; return; }
        g.on = true;
      }
      if (e.cancelable) e.preventDefault();
      var now = Date.now();
      g.v = (p.clientX - g.lx) / Math.max(1, now - g.lt) * g.dir;
      g.lx = p.clientX;
      g.lt = now;
      g.dx = Math.max(0, Math.min(g.w, dx * g.dir));
      move(g.d, g.base + g.dx * g.dir, null);
    }
 
    function end() {
      if (!g) return;
      var s = g;
      g = null;
      if (!s.on) return;
      stopClick = Date.now();
      if (s.dx > s.w * 0.3 || (s.v > 0.45 && s.dx > 30)) {
        /* out, then let the theme close it the usual way */
        var left = Math.max(120, Math.round((s.w - s.dx) / s.w * 260));
        move(s.d, s.base + s.w * s.dir, left + 'ms cubic-bezier(.3,.6,.4,1)');
        setTimeout(function () {
          var c = s.d.querySelector('.js-drawer-close');
          if (c) c.click();
          setTimeout(function () { clear(s.d); }, 450);
        }, left);
      } else {
        move(s.d, s.base, '.28s cubic-bezier(.2,.8,.2,1)');
        setTimeout(function () { if (!g || g.d !== s.d) clear(s.d); }, 300);
      }
    }
 
    ids.forEach(function (id) {
      var d = document.getElementById(id);
      if (!d) return;
      d.addEventListener('touchstart', start, { passive: true });
      d.addEventListener('touchmove', drag, { passive: false });
      d.addEventListener('touchend', end);
      d.addEventListener('touchcancel', end);
      /* a swipe is not a tap: no link opens when the finger lifts on it
         (the close click sent above is not a tap, so it goes through) */
      d.addEventListener('click', function (e) {
        if (e.isTrusted && Date.now() - stopClick < 400) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  })();
 
  /* =====================================================================
     THE PAGE STAYS STILL UNDER THE MENU AND THE CART (phones)
     The theme stops the page from scrolling while a drawer is open, but
     on purpose not on iPhones, so there the page moves under the menu
     and the cart. Here a finger moving up or down is only let through
     where something inside the open menu or cart can still scroll that
     way. On the dimmed page, the header, or past the end of the list it
     does nothing. The page layout is not touched, so nothing jumps when
     the drawer opens or closes. Sideways moves are left alone (swipe to
     close).
     ===================================================================== */
  /* box() says which box is open right now, or nothing. The same guard
     keeps the page still under the My sizes panel. */
  function touchLock(box) {
    var g = null;
    /* everything between the finger and the box that can scroll */
    function scrollers(t, d) {
      var list = [];
      for (var el = t; el && el.nodeType === 1; el = el.parentElement) {
        var oy = getComputedStyle(el).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1) list.push(el);
        if (el === d) break;
      }
      return list;
    }
    document.addEventListener('touchstart', function (e) {
      g = null;
      if (!e.touches || e.touches.length !== 1) return;
      var d = box();
      if (!d) return;
      var t = e.target && e.target.nodeType === 1 ? e.target : (e.target && e.target.parentElement);
      var inside = !!t && d.contains(t);
      g = { inside: inside, list: inside ? scrollers(t, d) : [], x: e.touches[0].clientX, y: e.touches[0].clientY, ly: e.touches[0].clientY, dir: '' };
    }, { passive: true });
    /* decided on the very first move: once the phone starts to scroll,
       it cannot be stopped any more */
    document.addEventListener('touchmove', function (e) {
      if (!g || !e.touches || e.touches.length !== 1 || !e.cancelable) return;
      var p = e.touches[0];
      if (!g.inside) { e.preventDefault(); return; }
      if (!g.dir) g.dir = Math.abs(p.clientY - g.y) >= Math.abs(p.clientX - g.x) ? 'y' : 'x';
      if (g.dir !== 'y') return;
      var step = p.clientY - g.ly;
      g.ly = p.clientY;
      if (!step) return;
      var can = g.list.some(function (el) {
        return step > 0 ? el.scrollTop > 0 : el.scrollTop + el.clientHeight < el.scrollHeight - 1;
      });
      if (!can) e.preventDefault();
    }, { passive: false });
    document.addEventListener('touchend', function () { g = null; }, { passive: true });
    document.addEventListener('touchcancel', function () { g = null; }, { passive: true });
  }
  if (CFG.scrollLock) touchLock(function () {
    if (!document.documentElement.classList.contains('js-drawer-open')) return null;
    return document.querySelector('.drawer.drawer--is-open');
  });
 
  /* =====================================================================
     EU SIZES ON THE SIZE BUTTONS (product pages)
     Under each US number a small "EU 35", from this model's own size
     chart (the EU printed inside the shoe), and "Size US / EU" above.
     Only what the shopper reads changes: the option value stays the US
     size Shopify stores, so the cart, the checkout and orders are the
     same. A model without a chart is left as it is.
     ===================================================================== */
  if (CFG.eu) (function () {
    var KS = window.KSFinder;
    if (!KS || typeof KS.build !== 'function') return;
    var me = KS.build({ t: '', u: '', s: CFG.eu.vals || [], a: '', g: CFG.eu.tags || [], c: [] });
    if (!me) return;
    var EU = {};
    me.rows.forEach(function (r) { if (!isNaN(r[2])) EU[r[0]] = r[2]; });
    var sel = 'input[type="radio"][data-index="option' + CFG.eu.pos + '"]';
 
    function paint() {
      var radios = document.querySelectorAll(sel), heads = [];
      Array.prototype.forEach.call(radios, function (r) {
        var w = r.closest('.variant-wrapper');
        if (w && heads.indexOf(w) < 0) heads.push(w);
        if (!r.id) return;
        var lab = document.querySelector('label[for="' + r.id.replace(/["\\]/g, '\\$&') + '"]');
        if (!lab || lab.querySelector('.kst-eu')) return;
        var eu = EU[num(r.value)];
        if (eu == null) return;
        lab.classList.add('kst-eu-lab');
        lab.innerHTML = '<span class="kst-us">' + esc(r.value) + '</span><span class="kst-eu">EU ' + eu + '</span>';
      });
      /* the heading above the buttons: "Size US" becomes "Size US / EU" */
      heads.forEach(function (w) {
        var h = w.querySelector('.variant__label');
        if (!h || h.hasAttribute('data-kst-eu')) return;
        var t = h.textContent.replace(/\s+/g, ' ').trim();
        h.setAttribute('data-kst-eu', '');
        if (t && !/\bEU\b/.test(t)) h.textContent = t + ' / EU';
      });
    }
    paint();
 
    /* the theme can draw the buttons again (a section reloaded in the
       editor, quick changes): label the new ones too */
    var first = document.querySelector(sel);
    var host = first ? (first.closest('.shopify-section') || first.closest('form') || document.body) : null;
    var t = null;
    if (host && window.MutationObserver) {
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(paint, 60); })
        .observe(host, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { setTimeout(paint, 60); });
  })();
 
  /* =====================================================================
     MY SIZES
     A ruler in the header: on phones next to the menu, on computers next
     to the search with its name. A green dot on it says sizes are saved.
     It opens one panel for all saved sizes (a sheet from the bottom on
     phones, from the left on computers):
       - each person with the foot length and fit, Edit and Delete
       - on a product page: the size in this shoe, and a button that
         selects it; anywhere else: shoes in stock in that size
       - Add a size: a foot length, or a Nike or Adidas size they wear
     Saved sizes are the same ones the size helper, the size chart and
     the size finder use (KSFinder.sizes), kept in this browser only.
     Also opens from any link to #my-sizes, from [data-kms-open], and
     from the size helper's Edit and Add a size.
     ===================================================================== */
  if (CFG.ms) (function () {
    var KS = window.KSFinder;
    var SV = KS && KS.sizes && KS.sizes.on ? KS.sizes : null;
    if (!SV || typeof KS.sizeFor !== 'function' || typeof KS.build !== 'function') return;
    var M = CFG.ms, html = document.documentElement;
    var ST = SV.t || {};
    function st(k, d) { var v = ST[k]; return v == null || v === '' ? d : v; }
    function ageTxt(m) { return m === 1 ? '1 month' : m + ' months'; }
    function short(t) {
      return String(t || '').replace(/^Kick Speed(™|&trade;)?\s*/i, '')
        .replace(/\s*(Heel Wheels?\s+)?Roller (Skate )?Shoes?\b/i, '').replace(/\s+/g, ' ').trim();
    }
    function small(src) {
      if (!src) return '';
      src = String(src).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
    }
 
    var IC = {
      ruler: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-ks-sizes" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M8 42 42 8l14 14-34 34z"/><path d="M16 34l5 5M23 27l3 3M30 20l5 5M37 13l3 3"/></svg>',
      x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
      back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
      check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
      plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
      info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.5"/></svg>',
      chev: '<svg class="kms-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'
    };
 
    /* ---------- the ruler in the header ---------- */
    var label = tx('ms_label', 'My sizes');
    var btns = [];
    function mkBtn(desk) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'site-nav__link site-nav__link--icon kms-btn' + (desk ? ' kms-btn--desk' : '');
      b.setAttribute('data-kms-open', '');
      b.setAttribute('aria-haspopup', 'dialog');
      b.innerHTML = '<span class="kms-ico">' + IC.ruler + '<span class="kms-dot" hidden></span></span>' +
        (desk ? '<span class="kms-lab">' + esc(label) + '</span>' : '');
      btns.push(b);
      return b;
    }
    var hdr = document.querySelector('.site-header');
    var navMob = hdr && hdr.querySelector('.header-item--navigation .site-nav.large-up--hide');
    var navDesk = hdr && hdr.querySelector('.header-item--navigation .site-nav.medium-down--hide');
    if (navMob) navMob.appendChild(mkBtn(false));
    if (navDesk) navDesk.appendChild(mkBtn(true));
 
    var lastN = SV.list().length;
    function dots(pulse) {
      var n = SV.list().length;
      btns.forEach(function (b) {
        b.querySelector('.kms-dot').hidden = !n;
        b.setAttribute('aria-label', n ? label + ' (' + n + ')' : label);
        if (pulse) {
          b.classList.remove('kms-pulse');
          void b.offsetWidth;
          b.classList.add('kms-pulse');
          setTimeout(function () { b.classList.remove('kms-pulse'); }, 1700);
        }
      });
    }
    dots(false);
 
    /* ---------- the panel ---------- */
    var S = { open: false, view: 'list', toast: '', opener: null };
    var F = null;
    var dlg = null, box = null, body = null, titleEl = null, bkBtn = null, resetSheet = function () {};
 
    function build() {
      dlg = document.createElement('div');
      dlg.className = 'kms';
      dlg.hidden = true;
      dlg.innerHTML =
        '<div class="kms-back" data-kms-close></div>' +
        '<div class="kms-box" role="dialog" aria-modal="true" aria-labelledby="kms-t">' +
          '<div class="kms-head"><span class="kms-grab" aria-hidden="true"></span>' +
            '<button type="button" class="kms-bk" data-kms-list aria-label="' + esc(st('cancel', 'Cancel')) + '" hidden>' + IC.back + '</button>' +
            '<div class="kms-htxt"><h2 class="kms-title" id="kms-t"></h2><p class="kms-sub">' + esc(st('private', 'Saved on this device only.')) + '</p></div>' +
            '<button type="button" class="kms-x" data-kms-close aria-label="Close">' + IC.x + '</button>' +
          '</div>' +
          '<div class="kms-body"></div>' +
        '</div>';
      document.body.appendChild(dlg);
      box = dlg.querySelector('.kms-box');
      body = dlg.querySelector('.kms-body');
      titleEl = dlg.querySelector('.kms-title');
      bkBtn = dlg.querySelector('.kms-bk');
      bind();
      resetSheet = bindSwipe();
    }
 
    function paint() {
      if (!dlg) return;
      bkBtn.hidden = S.view === 'list';
      titleEl.textContent = S.view === 'list' ? tx('ms_title', 'My sizes')
        : S.view === 'edit' ? plain(tx('ms_edit', 'Edit [name]'), { name: F.orig }) : tx('ms_add', 'Add a size');
      if (S.view === 'list') paintList(); else paintForm();
    }
 
    /* ---------- the list ---------- */
    function unitIn() { var l = KS.recall ? (KS.recall() || {}) : {}; return l.unit === 'in'; }
    function lenTxt(cm) {
      return unitIn() ? (cm / 2.54).toFixed(2) + ' in' : (Math.round(cm * 10) / 10).toFixed(1) + ' cm';
    }
    function fitName(k) { return (KS.fits[k] || KS.fits.comfort).label; }
    /* "your size" for Me, "Emma’s size" for everybody else */
    function who(p) {
      var me = /^(me|myself|my size|mine)$/i.test(p.name);
      return { name: p.name, whose: me ? 'your' : p.name + '’s' };
    }
    function initials(n) { return n.length <= 2 ? n : n.charAt(0).toUpperCase(); }
    function extraEl(id) {
      var all = body.querySelectorAll('[data-kms-extra]');
      for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-kms-extra') === id) return all[i];
      return null;
    }
 
    function card(p) {
      var sub = lenTxt(p.foot) + ' · ' + fitName(p.fit) + (p.socks ? ' · ' + tx('ms_socks', 'thick socks') : '');
      var h = '<div class="kms-card">' +
        '<div class="kms-row"><span class="kms-av" aria-hidden="true">' + esc(initials(p.name)) + '</span>' +
          '<div class="kms-who"><b>' + esc(p.name) + '</b><span>' + esc(sub) + '</span></div>' +
          '<button type="button" class="kms-tb" data-kms-edit="' + esc(p.id) + '" aria-label="' + esc(st('edit', 'Edit') + ' ' + p.name) + '">' + esc(st('edit', 'Edit')) + '</button>' +
          '<button type="button" class="kms-tb kms-del" data-kms-del="' + esc(p.id) + '" aria-label="' + esc(st('del', 'Delete') + ' ' + p.name) + '">' + esc(st('del', 'Delete')) + '</button>' +
        '</div>';
      if (SV.stale && SV.stale(p)) {
        h += '<p class="kms-note">' + esc(plain(st('remeasure', '[name] was measured [age] ago. Growing feet change fast.'), { name: p.name, age: ageTxt(SV.months(p)) })) +
          '<button type="button" class="kms-lk" data-kms-edit="' + esc(p.id) + '">' + esc(st('measure_again', 'Measure again')) + '</button></p>';
      }
      h += '<div data-kms-extra="' + esc(p.id) + '">' +
        (M.product ? '' : '<p class="kms-lab2">' + esc(plain(tx('ms_stock', 'In stock in [whose] size'), who(p))) + '</p><div class="kms-wait"></div>') +
        '</div>';
      return h + '</div>';
    }
 
    function paintList() {
      var list = SV.list(), h = '';
      if (S.toast) h += '<p class="kms-toast" role="status">' + IC.check + esc(S.toast) + '</p>';
      S.toast = '';
      if (!list.length) h += '<p class="kms-empty">' + esc(tx('ms_empty', 'Save a foot length once. Every shoe then shows the size that fits.')) + '</p>';
      list.forEach(function (p) { h += card(p); });
      if (list.length < SV.max) {
        h += '<button type="button" class="kms-add" data-kms-add>' + IC.plus + esc(tx('ms_add', 'Add a size')) + '</button>';
      } else {
        h += '<p class="kms-full">' + esc(plain(st('full', 'You can save up to [max] sizes. Delete one first.'), { max: SV.max })) + '</p>';
      }
      body.innerHTML = h;
      if (!list.length) return;
      if (M.product) loadHere(); else loadShoes();
    }
 
    /* ---------- this product ---------- */
    var PRODJ = null;
    function rawProduct() {
      if (!PRODJ) {
        PRODJ = getJSON(ROOT + 'products/' + encodeURIComponent(M.product) + '.js').then(null, function () { PRODJ = null; return null; });
      }
      return PRODJ;
    }
    function optIdx(raw, re) {
      var i = -1;
      (raw.options || []).forEach(function (o, n) {
        var nm = typeof o === 'string' ? o : o.name;
        if (i < 0 && re.test(nm)) i = n;
      });
      return i;
    }
    function pageColor(ci) {
      if (ci < 0) return '';
      var r = document.querySelector('input[type="radio"][data-index="option' + (ci + 1) + '"]:checked');
      if (r) return r.value;
      var s = document.querySelector('select[data-index="option' + (ci + 1) + '"]');
      return s ? s.value : '';
    }
    /* this product as the charts see it: the sizes in stock in the color
       chosen on the page */
    function thisShoe(raw) {
      if (!raw) return null;
      var si = optIdx(raw, /size/i), ci = optIdx(raw, /colou?r/i);
      if (si < 0) return null;
      var color = pageColor(ci), avail = '|';
      (raw.variants || []).forEach(function (v) {
        var o = v.options || [v.option1, v.option2, v.option3];
        if (!v.available) return;
        if (color && ci > -1 && o[ci] !== color) return;
        avail += o[si] + '|';
      });
      var o = raw.options[si];
      var b = KS.build({ t: raw.title, u: raw.url || '/products/' + raw.handle, s: o.values || [], a: avail, g: raw.tags || [], c: ci > -1 ? (raw.options[ci].values || []) : [] });
      return b ? { b: b, si: si, color: color } : null;
    }
    function hereHtml(p, x, preview) {
      var r = KS.sizeFor(x.b, p.foot, { fit: p.fit, socks: p.socks });
      if (!r) {
        return '<p class="kms-here is-out">' + IC.info + '<span>' + esc(plain(tx('ms_none', 'No size in this shoe fits [name].'), { name: p.name || '' })) + '</span></p>';
      }
      var pick = r.best || r.bestAny;
      var size = 'US ' + pick.us + (pick.eu ? ' · EU ' + pick.eu : '');
      var stock = r.best
        ? (x.color ? plain(tx('ms_in', 'in stock in [color]'), { color: x.color }) : tx('ms_in0', 'in stock'))
        : (x.color ? plain(tx('ms_out', 'sold out in [color]'), { color: x.color }) : tx('ms_out0', 'sold out'));
      return '<p class="kms-here' + (r.best ? '' : ' is-out') + '">' + (r.best ? IC.check : IC.info) + '<span>' +
          fill(tx('ms_here', '[size] in this shoe'), { size: '<b>' + esc(size) + '</b>' }) + ' · ' + esc(stock) + '</span></p>' +
        (r.best && !preview ? '<button type="button" class="kms-sel" data-kms-pick="' + esc(p.id) + '" data-us="' + pick.us + '">' +
          esc(plain(tx('ms_select', 'Select [size]'), { size: 'US ' + pick.us })) + '</button>' : '');
    }
    function loadHere() {
      rawProduct().then(function (raw) {
        if (!S.open || S.view !== 'list') return;
        var x = thisShoe(raw);
        if (!x) return;
        SV.list().forEach(function (p) {
          var el = extraEl(p.id);
          if (el) el.innerHTML = hereHtml(p, x, false);
        });
      });
    }
    /* Select: the size helper's own button for this person does it
       (color, stock and all); without the helper, the size button */
    function selectOnPage(id, us) {
      SV.pick(id);
      close(true);
      var chips = document.querySelectorAll('.ksh [data-pid]');
      for (var i = 0; i < chips.length; i++) {
        if (chips[i].getAttribute('data-pid') === id) { chips[i].click(); return; }
      }
      rawProduct().then(function (raw) {
        var x = raw && optIdx(raw, /size/i);
        if (x == null || x < 0) return;
        var ins = document.querySelectorAll('input[type="radio"][data-index="option' + (x + 1) + '"]');
        for (var j = 0; j < ins.length; j++) {
          if (num(ins[j].value) === us) { ins[j].click(); break; }
        }
      });
    }
 
    /* ---------- shoes in stock in that size ---------- */
    var SHOES = null;
    function loadShoes() {
      if (!SHOES) {
        SHOES = getJSON(ROOT + 'collections/' + encodeURIComponent(M.coll || 'all') + '/products.json?limit=250').then(function (d) {
          var out = [];
          (d.products || []).forEach(function (raw) {
            var si = optIdx(raw, /size/i), ci = optIdx(raw, /colou?r/i);
            if (si < 0) return;
            var avail = '|';
            (raw.variants || []).forEach(function (v) {
              if (v.available) avail += (v['option' + (si + 1)] || '') + '|';
            });
            var tags = raw.tags || [];
            if (typeof tags === 'string') tags = tags.split(',').map(function (t) { return t.trim(); });
            var b = KS.build({ t: raw.title, u: '/products/' + raw.handle, s: raw.options[si].values || [], a: avail, g: tags, c: ci > -1 ? (raw.options[ci].values || []) : [] });
            if (b) out.push({ b: b, img: (raw.images && raw.images[0] && raw.images[0].src) || '' });
          });
          return out;
        }, function () { SHOES = null; return []; });
      }
      SHOES.then(function (list) { if (S.open && S.view === 'list') fillShoes(list); });
    }
    function qs(p) { return 'ks_foot=' + p.foot + '&ks_fit=' + p.fit + (p.socks ? '&ks_socks=1' : ''); }
    function allUrl(p) {
      if (M.mine) return ROOT + 'collections/' + encodeURIComponent(M.coll || 'all');
      var f = M.finder || '/pages/size-finder';
      return f + (f.indexOf('?') > -1 ? '&' : '?') + qs(p);
    }
    function fillShoes(list) {
      SV.list().forEach(function (p) {
        var el = extraEl(p.id);
        if (!el) return;
        var hits = [];
        list.forEach(function (s) {
          var r = KS.sizeFor(s.b, p.foot, { fit: p.fit, socks: p.socks });
          if (r && r.best) hits.push({ s: s, us: r.best.us });
        });
        var head = '<p class="kms-lab2">' + esc(plain(tx('ms_stock', 'In stock in [whose] size'), who(p))) + '</p>';
        if (!hits.length) {
          el.innerHTML = head + '<p class="kms-note">' + esc(plain(tx('ms_nostock', 'Nothing is in stock in [whose] size right now.'), who(p))) + '</p>';
          return;
        }
        var q = qs(p), max = M.count || 8;
        el.innerHTML = head + '<div class="kms-shoes">' + hits.slice(0, max).map(function (h) {
          var u = h.s.b.url;
          return '<a class="kms-shoe" href="' + esc(u + (u.indexOf('?') > -1 ? '&' : '?') + q) + '" data-kms-go="' + esc(p.id) + '">' +
            '<i>' + (h.s.img ? '<img src="' + esc(small(h.s.img)) + '" alt="" loading="lazy" width="112" height="112">' : '') + '</i>' +
            '<span>' + esc(short(h.s.b.title)) + '</span><b>US ' + esc(h.us) + '</b></a>';
        }).join('') + '</div>' +
          /* only when there are more than the row shows */
          (hits.length > max ? '<a class="kms-lk kms-all" href="' + esc(allUrl(p)) + '" data-kms-all="' + esc(p.id) + '">' +
            esc(plain(tx('ms_all', 'See all [count]'), { count: hits.length, name: p.name })) + '</a>' : '');
        var row = el.querySelector('.kms-shoes');
        if (row) {
          row.addEventListener('scroll', function () { rowEdges(row); }, { passive: true });
          rowEdges(row);
        }
      });
    }
    /* the side of the row with more shoes to see fades out */
    function rowEdges(el) {
      var max = el.scrollWidth - el.clientWidth;
      el.classList.toggle('kms-more-l', max > 2 && el.scrollLeft > 2);
      el.classList.toggle('kms-more-r', max > 2 && el.scrollLeft < max - 2);
    }
 
    /* ---------- add and edit ---------- */
    function newForm(p) {
      var last = KS.recall ? (KS.recall() || {}) : {};
      var bl = KS.brandList ? KS.brandList() : [];
      F = {
        id: p ? p.id : '', orig: p ? p.name : '', name: p ? p.name : '',
        mode: 'foot', unit: last.unit === 'in' ? 'in' : 'cm',
        foot: p ? p.foot : NaN, fit: p ? p.fit : 'comfort', socks: p ? !!p.socks : false,
        brand: bl.length ? bl[0].brand : '', gender: bl.length ? bl[0].genders[0].key : '', sys: 'us', label: ''
      };
    }
    function footNow() {
      if (F.mode === 'shoe') {
        var cm = F.label ? KS.brandToCm(F.brand, F.gender, F.label) : null;
        return cm == null ? NaN : cm;
      }
      return F.foot;
    }
    function paintForm() {
      var used = {};
      SV.list().forEach(function (p) { used[p.name.toLowerCase()] = 1; });
      var sugs = (SV.names || []).filter(function (n) { return !used[n.toLowerCase()] || n.toLowerCase() === F.orig.toLowerCase(); });
      var bl = KS.brandList ? KS.brandList() : [];
      var fits = ['snug', 'comfort', 'grow'].filter(function (k) { return KS.fits[k]; });
      body.innerHTML =
        '<label class="kms-lb" for="kms-name">' + esc(tx('ms_name', 'Name')) + '</label>' +
        '<input class="kms-in" id="kms-name" data-kms-name maxlength="24" autocomplete="off" placeholder="' + esc(st('name', 'Name, like Emma')) + '" value="' + esc(F.name) + '">' +
        (sugs.length ? '<div class="kms-sugs">' + sugs.map(function (n) {
          return '<button type="button" class="kms-chip" data-kms-sug="' + esc(n) + '">' + esc(n) + '</button>';
        }).join('') + '</div>' : '') +
        (bl.length
          ? '<span class="kms-lb">' + esc(tx('ms_know', 'I know')) + '</span>' +
            '<div class="kms-seg" role="group"><button type="button" data-kms-mode="foot">' + esc(tx('ms_foot', 'My foot length')) + '</button>' +
            '<button type="button" data-kms-mode="shoe">' + esc(tx('ms_shoe', 'My shoe size')) + '</button></div>'
          : '<span class="kms-lb">' + esc(tx('ms_foot', 'My foot length')) + '</span>') +
        '<div data-kms-pane="foot">' +
          '<div class="kms-dial"><button type="button" class="kms-pm" data-kms-pm="-1" aria-label="Shorter">−</button>' +
            '<label class="kms-num"><input type="number" inputmode="decimal" data-kms-foot aria-label="' + esc(tx('ms_foot', 'My foot length')) + '"><span data-kms-u></span></label>' +
            '<button type="button" class="kms-pm" data-kms-pm="1" aria-label="Longer">+</button></div>' +
          '<div class="kms-seg kms-units" role="group"><button type="button" data-kms-unit="cm">cm</button><button type="button" data-kms-unit="in">in</button></div>' +
          '<button type="button" class="kms-how" data-kms-how aria-expanded="false" aria-controls="kms-howbox">' + IC.ruler +
            '<span>' + esc(tx('ms_how', 'How to measure your foot')) + '</span>' + IC.chev + '</button>' +
          '<div class="kms-howbox" id="kms-howbox"><div class="kms-howin">' +
            (M.img ? '<img src="' + esc(M.img) + '" alt="' + esc(M.imgAlt || '') + '" loading="lazy" width="720" height="440">' : '') +
            '<p>' + esc(tx('ms_measure', 'Put a sheet of paper on the floor and stand on it. Mark the back of the heel and the tip of the longest toe, then measure between the two marks. Measure both feet and use the longer one.')) + '</p>' +
          '</div></div>' +
        '</div>' +
        (bl.length
          ? '<div data-kms-pane="shoe">' +
              '<div class="kms-2"><select class="kms-selx" data-kms-brand aria-label="Brand">' +
                bl.map(function (b) { return '<option value="' + esc(b.brand) + '">' + esc(b.name) + '</option>'; }).join('') +
              '</select><select class="kms-selx" data-kms-gender aria-label="For"></select></div>' +
              '<div class="kms-2"><div class="kms-seg" role="group"><button type="button" data-kms-sys="us">US</button><button type="button" data-kms-sys="eu">EU</button></div>' +
              '<select class="kms-selx" data-kms-size aria-label="Size"></select></div>' +
              '<p class="kms-conv" data-kms-conv hidden></p>' +
            '</div>'
          : '') +
        '<span class="kms-lb">' + esc(tx('ms_fit', 'Fit')) + '</span>' +
        '<div class="kms-fits" role="group">' + fits.map(function (k) {
          return '<button type="button" class="kms-fit" data-kms-fit="' + k + '">' + esc(KS.fits[k].label) + '<small>' + esc(KS.fits[k].note || '') + '</small></button>';
        }).join('') + '</div>' +
        '<label class="kms-socks"><input type="checkbox" data-kms-socks' + (F.socks ? ' checked' : '') + '>' + esc(tx('ms_socks_l', 'Thick socks')) + '</label>' +
        (M.product ? '<div data-kms-prev></div>' : '') +
        '<p class="kms-err" role="alert" data-kms-err></p>' +
        '<button type="button" class="kms-save" data-kms-save></button>' +
        '<div class="kms-foot2"><button type="button" class="kms-lk" data-kms-list>' + esc(st('cancel', 'Cancel')) + '</button>' +
          (F.id ? '<button type="button" class="kms-tb kms-del" data-kms-del="' + esc(F.id) + '">' + esc(st('del', 'Delete')) + '</button>' : '') +
        '</div>';
      body.scrollTop = 0;
      syncForm();
    }
    function press(list, attr, value) {
      Array.prototype.forEach.call(body.querySelectorAll('[' + attr + ']'), function (b) {
        var on = b.getAttribute(attr) === value;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
      });
    }
    function syncForm() {
      if (!F) return;
      function q(s) { return body.querySelector(s); }
      press(null, 'data-kms-mode', F.mode);
      press(null, 'data-kms-unit', F.unit);
      press(null, 'data-kms-sys', F.sys);
      press(null, 'data-kms-fit', F.fit);
      Array.prototype.forEach.call(body.querySelectorAll('[data-kms-pane]'), function (p) {
        p.hidden = p.getAttribute('data-kms-pane') !== F.mode;
      });
      var inp = q('[data-kms-foot]');
      if (inp) {
        inp.step = F.unit === 'in' ? '0.05' : '0.1';
        inp.placeholder = F.unit === 'in' ? '9.45' : '24.0';
        if (document.activeElement !== inp) {
          inp.value = isNaN(F.foot) ? '' : F.unit === 'in' ? (F.foot / 2.54).toFixed(2) : F.foot.toFixed(1);
        }
      }
      var u = q('[data-kms-u]');
      if (u) u.textContent = F.unit;
      var gs = q('[data-kms-gender]');
      if (gs) {
        var bl = KS.brandList(), br = bl.filter(function (x) { return x.brand === F.brand; })[0] || bl[0];
        F.brand = br.brand;
        if (!br.genders.some(function (g) { return g.key === F.gender; })) F.gender = br.genders[0].key;
        q('[data-kms-brand]').value = F.brand;
        var gh = br.genders.map(function (g) { return '<option value="' + esc(g.key) + '">' + esc(g.name) + '</option>'; }).join('');
        if (gs._k !== gh) { gs.innerHTML = gh; gs._k = gh; }
        gs.value = F.gender;
        var sizes = KS.brandSizes(F.brand, F.gender);
        if (!sizes.some(function (s) { return s.label === F.label; })) F.label = '';
        var sh = '<option value="">' + esc(tx('ms_size', 'Size')) + '</option>' + sizes.map(function (s) {
          return '<option value="' + esc(s.label) + '">' + esc(KS.brandSizeLabel(s, F.sys)) + '</option>';
        }).join('');
        var ss = q('[data-kms-size]');
        if (ss._k !== sh) { ss.innerHTML = sh; ss._k = sh; }
        ss.value = F.label;
        var conv = q('[data-kms-conv]'), cm = footNow();
        if (F.mode === 'shoe' && !isNaN(cm)) {
          conv.hidden = false;
          conv.innerHTML = fill(tx('ms_conv', 'That fits a foot of about [cm] on the [brand] chart. A real measurement is more exact.'),
            { cm: '<b>' + esc(cm.toFixed(1)) + ' cm</b> (' + esc((cm / 2.54).toFixed(2)) + ' in)', brand: esc(KS.brandName(F.brand)) });
        } else {
          conv.hidden = true;
        }
      }
      var pv = q('[data-kms-prev]');
      if (pv) {
        var foot = footNow();
        if (isNaN(foot)) pv.innerHTML = '';
        else rawProduct().then(function (raw) {
          var x = thisShoe(raw);
          if (!F || !x || !pv.isConnected) return;
          var f2 = footNow();
          pv.innerHTML = isNaN(f2) ? '' : hereHtml({ foot: f2, fit: F.fit, socks: F.socks, name: SV.clean(F.name) || tx('ms_this', 'this foot') }, x, true);
        });
      }
      var sv = q('[data-kms-save]');
      if (sv) sv.textContent = F.id ? plain(st('update', 'Update [name]'), { name: F.orig }) : tx('ms_save', 'Save size');
    }
    function err(msg, focusEl) {
      var e = body.querySelector('[data-kms-err]');
      if (e) e.textContent = msg || '';
      if (msg && focusEl && focusEl.focus) focusEl.focus();
      return false;
    }
    function save() {
      var nameIn = body.querySelector('[data-kms-name]');
      F.name = nameIn.value;
      var name = SV.clean(F.name), foot = footNow();
      if (!name) return err(st('need_name', 'Give it a name first.'), nameIn);
      var twin = !F.id && SV.byName(name);
      if (twin) return err(plain(st('taken', '[name] is already saved. Pick another name.'), { name: twin.name }), nameIn);
      if (isNaN(foot) || foot < 12 || foot > 34) {
        return err(F.mode === 'shoe' ? tx('ms_pick_err', 'Choose the size you wear.') : tx('ms_foot_err', 'Enter a foot length between 12 and 34 cm.'),
          body.querySelector(F.mode === 'shoe' ? '[data-kms-size]' : '[data-kms-foot]'));
      }
      var res = SV.save({ id: F.id || undefined, name: name, foot: foot, fit: F.fit, socks: F.socks });
      if (res.error) {
        return err(res.error === 'taken' ? plain(st('taken', '[name] is already saved. Pick another name.'), { name: name })
          : res.error === 'full' ? plain(st('full', 'You can save up to [max] sizes. Delete one first.'), { max: SV.max })
          : res.error === 'name' ? st('need_name', 'Give it a name first.')
          : tx('ms_store_err', 'This browser did not let us save it.'));
      }
      if (KS.remember) KS.remember({ foot: res.item.foot, fit: res.item.fit, socks: res.item.socks, unit: F.unit });
      SV.pick(res.item.id);
      KS.track('ks_mysizes_saved', { from: F.mode, updated: !!res.updated });
      S.toast = plain(st('saved_ok', 'Saved as [name]'), { name: res.item.name });
      S.view = 'list';
      F = null;
      paint();
      return true;
    }
    function armDelete(b, id) {
      var p = SV.get(id);
      if (!p) { paint(); return; }
      if (!b.classList.contains('is-armed')) {
        b.classList.add('is-armed');
        b.textContent = plain(st('del_ask', 'Delete [name]?'), { name: p.name });
        clearTimeout(b._t);
        b._t = setTimeout(function () {
          if (!b.isConnected) return;
          b.classList.remove('is-armed');
          b.textContent = st('del', 'Delete');
        }, 4000);
        return;
      }
      SV.remove(id);
      S.view = 'list';
      F = null;
      paint();
    }
    function step(dir) {
      var f = F.foot;
      if (isNaN(f)) f = 24;
      else if (F.unit === 'in') f = Math.round((f / 2.54 + dir * 0.05) * 2.54 * 10) / 10;
      else f = Math.round((f + dir * 0.1) * 10) / 10;
      F.foot = Math.min(34, Math.max(12, f));
      err('');
      syncForm();
    }
 
    /* ---------- open and close ---------- */
    function openForm(p) { newForm(p); S.view = p ? 'edit' : 'add'; }
    function open(o) {
      o = o || {};
      if (!dlg) build();
      if (!S.open) S.opener = o.opener || document.activeElement;
      if (o.view === 'add' && SV.list().length < SV.max) openForm(null);
      else if (o.view === 'edit' && o.id && SV.get(o.id)) openForm(SV.get(o.id));
      else if (!S.open || o.view === 'list') { S.view = 'list'; F = null; }
      paint();
      if (S.open) return;
      S.open = true;
      resetSheet();
      dlg.hidden = false;
      html.classList.add('kms-lock');
      setTimeout(function () { dlg.classList.add('is-open'); }, 20);
      setTimeout(function () {
        var t = S.view === 'list' ? dlg.querySelector('.kms-x') : dlg.querySelector('[data-kms-name]');
        if (t) try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); }
      }, 60);
      KS.track('ks_mysizes_open', { saved: SV.list().length, view: S.view });
    }
    function close(keepFocus) {
      if (!dlg || !S.open) return;
      S.open = false;
      dlg.classList.remove('is-open');
      html.classList.remove('kms-lock');
      setTimeout(function () { if (!S.open) { dlg.hidden = true; resetSheet(); } }, 360);
      if (!keepFocus && S.opener && S.opener.focus) { try { S.opener.focus(); } catch (e) {} }
    }
 
    function bind() {
      dlg.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('[data-kms-close]')) { close(); return; }
        var a = t.closest('a[data-kms-go], a[data-kms-all]');
        if (a) {
          var pid = a.getAttribute('data-kms-go') || a.getAttribute('data-kms-all');
          SV.pick(pid);
          if (a.hasAttribute('data-kms-all') && M.mine) {
            store('session', 'kst_mine', pid);
            if (M.only) store('session', 'kst_only', '1');
          }
          return;
        }
        var b = t.closest('button');
        if (!b || !dlg.contains(b)) return;
        if (b.hasAttribute('data-kms-list')) { S.view = 'list'; F = null; paint(); return; }
        if (b.hasAttribute('data-kms-add')) { openForm(null); paint(); focusName(); return; }
        if (b.hasAttribute('data-kms-edit')) { var p = SV.get(b.getAttribute('data-kms-edit')); if (p) { openForm(p); paint(); } return; }
        if (b.hasAttribute('data-kms-del')) { armDelete(b, b.getAttribute('data-kms-del')); return; }
        if (b.hasAttribute('data-kms-pick')) { selectOnPage(b.getAttribute('data-kms-pick'), parseFloat(b.getAttribute('data-us'))); return; }
        if (!F) return;
        if (b.hasAttribute('data-kms-sug')) {
          var n = body.querySelector('[data-kms-name]');
          n.value = F.name = b.getAttribute('data-kms-sug');
          err('');
          return;
        }
        if (b.hasAttribute('data-kms-mode')) { F.mode = b.getAttribute('data-kms-mode'); err(''); syncForm(); return; }
        if (b.hasAttribute('data-kms-unit')) { F.unit = b.getAttribute('data-kms-unit'); syncForm(); return; }
        if (b.hasAttribute('data-kms-sys')) { F.sys = b.getAttribute('data-kms-sys'); syncForm(); return; }
        if (b.hasAttribute('data-kms-fit')) { F.fit = b.getAttribute('data-kms-fit'); syncForm(); return; }
        if (b.hasAttribute('data-kms-pm')) { step(+b.getAttribute('data-kms-pm')); return; }
        if (b.hasAttribute('data-kms-how')) { howToggle(b); return; }
        if (b.hasAttribute('data-kms-save')) { save(); return; }
      });
      /* computers: drag the row of shoes with the mouse. A drag is not a
         click, so no shoe opens when the button is let go */
      var drag = null, dragEnd = 0;
      dlg.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        var row = e.target && e.target.closest ? e.target.closest('.kms-shoes') : null;
        if (!row || row.scrollWidth <= row.clientWidth + 2) return;
        drag = { row: row, x: e.clientX, sl: row.scrollLeft, moved: false };
      });
      document.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved) {
          if (Math.abs(dx) < 5) return;
          drag.moved = true;
          drag.row.classList.add('is-drag');
        }
        drag.row.scrollLeft = drag.sl - dx;
      });
      function dragStop() {
        if (!drag) return;
        var d = drag;
        drag = null;
        d.row.classList.remove('is-drag');
        if (d.moved) dragEnd = Date.now();
      }
      document.addEventListener('pointerup', dragStop);
      window.addEventListener('blur', dragStop);
      dlg.addEventListener('click', function (e) {
        if (Date.now() - dragEnd < 350 && e.target && e.target.closest && e.target.closest('.kms-shoes')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
      dlg.addEventListener('dragstart', function (e) {
        if (e.target && e.target.closest && e.target.closest('.kms-shoes')) e.preventDefault();
      });
      dlg.addEventListener('input', function (e) {
        if (!F) return;
        var t = e.target;
        if (t.hasAttribute('data-kms-name')) { F.name = t.value; err(''); return; }
        if (t.hasAttribute('data-kms-foot')) {
          var raw = t.value.trim();
          F.foot = raw ? KS.toCm(raw, F.unit) : NaN;
          err('');
          syncForm();
        }
      });
      dlg.addEventListener('change', function (e) {
        if (!F) return;
        var t = e.target;
        if (t.hasAttribute('data-kms-brand')) { F.brand = t.value; F.label = ''; }
        else if (t.hasAttribute('data-kms-gender')) { F.gender = t.value; F.label = ''; }
        else if (t.hasAttribute('data-kms-size')) { F.label = t.value; }
        else if (t.hasAttribute('data-kms-socks')) { F.socks = !!t.checked; }
        else return;
        err('');
        syncForm();
      });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key === 'Enter' && F && e.target && e.target.matches && e.target.matches('input:not([type="checkbox"])')) { e.preventDefault(); save(); return; }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(box.querySelectorAll('button, [href], input, select'), function (el) {
          return !el.disabled && el.offsetParent !== null;
        });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
    }
    /* How to measure: closed until tapped, then it slides open under the
       button and comes into view */
    function howToggle(b) {
      var boxEl = body.querySelector('.kms-howbox');
      if (!boxEl) return;
      var open = !boxEl.classList.contains('is-open');
      boxEl.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', String(open));
      if (open) {
        KS.track('ks_mysizes_how', {});
        setTimeout(function () {
          var r = boxEl.getBoundingClientRect(), bb = body.getBoundingClientRect();
          if (r.bottom > bb.bottom) {
            try { body.scrollTo({ top: body.scrollTop + r.bottom - bb.bottom + 16, behavior: 'smooth' }); } catch (e) { body.scrollTop += r.bottom - bb.bottom + 16; }
          }
        }, 260);
      }
    }
    function focusName() {
      setTimeout(function () { var n = body.querySelector('[data-kms-name]'); if (n) n.focus(); }, 30);
    }
 
    /* phones: pulled down, the sheet closes, like the size chart */
    function bindSwipe() {
      var mq = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
      var head = dlg.querySelector('.kms-head'), back = dlg.querySelector('.kms-back');
      var g = null, stopClick = 0;
      function sheet(y, anim) {
        box.style.transition = anim ? 'transform .25s cubic-bezier(.2,.8,.2,1)' : 'none';
        box.style.transform = y ? 'translateY(' + y + 'px)' : '';
        back.style.transition = anim ? 'opacity .25s' : 'none';
        back.style.opacity = y ? String(Math.max(0.15, 1 - y / (box.offsetHeight || 600))) : '';
      }
      function clear() {
        box.style.transition = ''; box.style.transform = '';
        back.style.transition = ''; back.style.opacity = '';
      }
      dlg.addEventListener('touchstart', function (e) {
        g = null;
        if (!S.open || !mq || !mq.matches || !e.touches || e.touches.length !== 1) return;
        var t = e.target;
        if (!t || !t.closest || !box.contains(t)) return;
        if (t.closest('input, select, textarea, .kms-pm, .kms-shoes')) return;
        var p = e.touches[0];
        g = { x: p.clientX, y: p.clientY, head: head.contains(t), top: body.scrollTop <= 0, on: false, dy: 0, ly: p.clientY, lt: Date.now(), v: 0 };
      }, { passive: true });
      dlg.addEventListener('touchmove', function (e) {
        if (!g || !e.touches || !e.touches.length) return;
        var p = e.touches[0], dx = p.clientX - g.x, dy = p.clientY - g.y;
        if (!g.on) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (dy <= 0 || Math.abs(dx) > Math.abs(dy) || (!g.head && (!g.top || body.scrollTop > 0))) { g = null; return; }
          g.on = true;
        }
        if (e.cancelable) e.preventDefault();
        var now = Date.now();
        g.v = (p.clientY - g.ly) / Math.max(1, now - g.lt);
        g.ly = p.clientY; g.lt = now;
        g.dy = Math.max(0, p.clientY - g.y);
        sheet(g.dy, false);
      }, { passive: false });
      function end() {
        if (!g) return;
        var was = g;
        g = null;
        if (!was.on) return;
        stopClick = Date.now();
        if (was.dy > Math.min(140, box.offsetHeight * 0.25) || (was.v > 0.5 && was.dy > 24)) {
          box.style.transition = 'transform .22s ease-in';
          box.style.transform = 'translateY(100%)';
          back.style.transition = ''; back.style.opacity = '';
          close();
        } else {
          sheet(0, true);
          setTimeout(function () { if (!g) clear(); }, 300);
        }
      }
      dlg.addEventListener('touchend', end);
      dlg.addEventListener('touchcancel', end);
      dlg.addEventListener('click', function (e) {
        if (Date.now() - stopClick < 400) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      return clear;
    }
    touchLock(function () { return S.open && box ? box : null; });
 
    /* ---------- what opens it ---------- */
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-kms-open], a[href$="#my-sizes"]') : null;
      if (!t || (dlg && dlg.contains(t))) return;
      e.preventDefault();
      var dr = document.querySelector('.drawer.drawer--is-open .js-drawer-close');
      if (dr) dr.click();
      open({ opener: t, view: t.getAttribute('data-kms-open') || '' });
    });
    document.addEventListener('ks:mysizes', function (e) {
      var d = e.detail || {};
      open({ view: d.view, id: d.id, opener: d.opener });
    });
    document.addEventListener('ks:sizes', function () {
      var n = SV.list().length;
      dots(n > lastN && !S.open);
      lastN = n;
      if (S.open && S.view === 'list') paint();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { lastN = SV.list().length; dots(false); } });
    window.KSMySizes = { open: open, close: close };
    if (location.hash === '#my-sizes') setTimeout(function () { open({}); }, 300);
  })();
 
  /* =====================================================================
     SIZES WITH THE ORDER
     The shopper's saved sizes go with the order, so the order in the
     admin shows them under Additional details, for example:
       Saved sizes:  Emma: 21.5 cm, Room to grow · Me: 26.5 cm, Comfort
       Size check:   Kick Speed ... – White / 4: OK for Emma (best US 3.5)
     The size check says, for every shoe in the cart, whose saved size it
     fits, or that it fits nobody's (too small or too big, with the best
     size), so a wrong size can be caught before the parcel leaves.
     Written into the cart (cart attributes) when the cart or the saved
     sizes change, only for shoppers with a saved size; taken out again
     when they delete their sizes. Nothing is shown to the shopper.
 
     Sizes from the account: Shopify Flow copies "Saved sizes" from each
     order into the customer (metafield custom.saved_sizes). When that
     customer is signed in, the sizes there are added to My sizes on
     this device: a name that is not saved here yet is added, and a name
     measured more recently in the account is updated. It runs once per
     new account value, so a size deleted on this device stays deleted
     until the next order brings a new value.
     ===================================================================== */
  if (CFG.os) (function () {
    var K_SIZES = 'Saved sizes', K_CHECK = 'Size check';
    var timer = null, running = false, queued = false;
 
    function fitName(key) {
      var k = KS(), f = k && k.fits && (k.fits[key] || k.fits.comfort);
      return f ? f.label : key;
    }
    function day(t) {
      var d = new Date(+t || Date.now());
      function two(n) { return (n < 10 ? '0' : '') + n; }
      return d.getFullYear() + '-' + two(d.getMonth() + 1) + '-' + two(d.getDate());
    }
    /* "Emma: 21.5 cm, Room to grow, measured 2026-10-02 · Me: ..." */
    function sizesText(people) {
      return people.map(function (p) {
        var name = String(p.name).replace(/·/g, ' ').replace(/\s+/g, ' ').trim();
        return name + ': ' + (+p.foot).toFixed(1) + ' cm, ' + fitName(p.fit) +
          (p.socks ? ', thick socks' : '') + ', measured ' + day(p.t);
      }).join(' · ');
    }
    function fitKey(label) {
      var k = KS(), f = (k && k.fits) || {}, want = String(label || '').trim().toLowerCase();
      for (var key in f) {
        if (Object.prototype.hasOwnProperty.call(f, key) && String(f[key].label).toLowerCase() === want) return key;
      }
      return 'comfort';
    }
    function parseSizes(text) {
      return String(text || '').split(/\s*·\s*|\n+/).map(function (part) {
        var m = /^(.+): (\d+(?:\.\d+)?) cm, (.+?)(, thick socks)?(?:, measured (\d{4})-(\d{2})-(\d{2}))?$/.exec(part.trim());
        if (!m) return null;
        return {
          name: m[1].trim(), foot: +m[2], fit: fitKey(m[3]), socks: !!m[4],
          t: m[5] ? new Date(+m[5], +m[6] - 1, +m[7]).getTime() : 0
        };
      }).filter(Boolean);
    }
    function fromAccount() {
      var sv = SV(), text = CFG.acct;
      if (!sv || !text || store('local', 'ks_sizes_acct') === text) return;
      var added = 0, updated = 0;
      parseSizes(text).forEach(function (a) {
        var mine = sv.byName(a.name), r = null;
        if (!mine) {
          r = sv.save({ name: a.name, foot: a.foot, fit: a.fit, socks: a.socks });
          if (r && r.item) added++;
        } else if (a.t > (+mine.t || 0) && (mine.foot !== a.foot || mine.fit !== a.fit || mine.socks !== a.socks)) {
          r = sv.save({ id: mine.id, name: mine.name, foot: a.foot, fit: a.fit, socks: a.socks });
          if (r && r.item) updated++;
        }
      });
      store('local', 'ks_sizes_acct', text);
      if (added || updated) track('ks_sizes_from_account', { added: added, updated: updated });
    }
    function variantById(p, id) {
      for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id) return p.variants[i];
      return null;
    }
 
    /* one cart line: "Title – White / 4: fits Emma" or "": not a shoe
       with a size chart */
    function lineCheck(line, people) {
      if (!line.handle || line.gift_card || line.product_has_only_default_variant) return Promise.resolve(null);
      return product(line.handle).then(function (p) {
        var k = KS();
        if (!k || p.sizeIdx < 0) return null;
        var v = variantById(p, line.variant_id);
        if (!v) return null;
        var us = num(v.opts[p.sizeIdx]);
        var chart = chartOf(p, null);
        if (!chart || isNaN(us)) return null;
        var ok = [], off = [];
        people.forEach(function (who) {
          var r = k.sizeFor(chart, who.foot, { fit: who.fit, socks: who.socks });
          if (!r || !r.bestAny) { off.push(who.name + ': no size in this shoe'); return; }
          var best = r.bestAny.us;
          if (best === us) { ok.push('fits ' + who.name); return; }
          var near = r.all.some(function (c) { return c.us === us; });
          if (near) ok.push('OK for ' + who.name + ' (best US ' + best + ')');
          else off.push(who.name + (us < best ? ' too small' : ' too big') + ' (best US ' + best + ')');
        });
        var name = (line.product_title || p.title) + (line.variant_title ? ' – ' + line.variant_title : '');
        return { ok: ok.length > 0, text: name + ': ' + (ok.length ? ok.join(', ') : 'fits no saved size: ' + off.join(', ')) };
      }, function () { return null; });
    }
 
    function done() {
      running = false;
      if (queued) { queued = false; schedule(); }
    }
 
    function run() {
      if (running) { queued = true; return; }
      if (!KS()) return;
      running = true;
      var sv = SV();
      var people = sv ? sv.list() : [];
      getJSON(ROOT + 'cart.js').then(function (cart) {
        var attrs = cart.attributes || {};
        var hadSizes = attrs[K_SIZES] != null && attrs[K_SIZES] !== '';
        var hadCheck = attrs[K_CHECK] != null && attrs[K_CHECK] !== '';
        if (!people.length) {
          if (!hadSizes && !hadCheck) return null;
          return { sizes: '', check: '', lines: [] };
        }
        if (!cart.item_count) return null;
        return Promise.all((cart.items || []).map(function (l) { return lineCheck(l, people); })).then(function (rows) {
          rows = rows.filter(Boolean);
          var want = { sizes: sizesText(people), check: rows.map(function (r) { return r.text; }).join(' | '), lines: rows };
          if ((attrs[K_SIZES] || '') === want.sizes && (attrs[K_CHECK] || '') === want.check) return null;
          return want;
        });
      }).then(function (want) {
        if (!want) return null;
        var a = {};
        a[K_SIZES] = want.sizes;
        a[K_CHECK] = want.check;
        return getJSON(ROOT + 'cart/update.js', { method: 'POST', body: { attributes: a } }).then(function () {
          if (want.sizes) {
            track('ks_order_sizes', {
              saved_count: people.length,
              lines: want.lines.length,
              lines_fit: want.lines.filter(function (r) { return r.ok; }).length,
              lines_no_fit: want.lines.filter(function (r) { return !r.ok; }).length
            });
          }
        });
      }).then(done, done);
    }
 
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(run, 600);
    }
 
    document.addEventListener('ks:sizes', schedule);
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('ajaxProduct:added', schedule);
    window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
    if (CFG.acct) fromAccount();
    var sv0 = SV();
    if (sv0 && sv0.list().length) schedule();
  })();
 
  /* =====================================================================
     CURRENCY IN THE MENU (phones)
     A pill under the social icons in the menu: the flag and the code of
     the currency the prices are shown in. Tapping it opens the phone's
     own list of the currencies set in the currency app (Nova / Booster).
     Picking one asks the app to change it, exactly as its own button
     does, so the app still converts every price and remembers the choice.
     The app's floating button is hidden on phones only while this pill
     works; if the app never shows up, the button is given back.
     ===================================================================== */
  if (CFG.curMenu) (function () {
    var root = document.documentElement;
    var nav = document.getElementById('NavDrawer');
    var social = nav && nav.querySelector('.mobile-nav__social');
    var spot = social ? social.parentNode : (nav && nav.querySelector('.drawer__scrollable'));
    if (!spot) return;
    root.classList.add('kst-curm');
    var sel = null, shown = null, tries = 0;
 
    /* "EUR" -> the EU flag, "GBP" -> the UK flag; X.. codes have none */
    function flag(code) {
      if (!/^[A-WYZ][A-Z]/.test(code || '') || !String.fromCodePoint) return '';
      return String.fromCodePoint(0x1F1E6 + code.charCodeAt(0) - 65, 0x1F1E6 + code.charCodeAt(1) - 65);
    }
    function codeOf(li) { return li.getAttribute('rel') || li.id || ''; }
    function items() { return $$('.bacurr-cur-block li.currMovers'); }
    function current() {
      var c = document.querySelector('.bacurr-cur-block .ba-chosen');
      var v = c ? c.textContent.trim() : '';
      if (!v) { try { v = JSON.parse(store('session', 'bacurr_user_cur') || 'null') || ''; } catch (e) { v = ''; } }
      return v;
    }
    function paint() {
      if (!sel) return;
      var c = current();
      if (!c) return;
      if (sel.value !== c) sel.value = c;
      shown.innerHTML = (flag(c) ? '<span class="kst-cur-f" aria-hidden="true">' + flag(c) + '</span>' : '') +
        '<span class="kst-cur-c">' + esc(c) + '</span>';
    }
 
    function build(list) {
      var row = document.createElement('div');
      row.className = 'kst-curw';
      var opts = list.map(function (li) {
        var code = codeOf(li), f = flag(code);
        var name = (li.textContent || '').replace(/\s+/g, ' ').trim() || code;
        return '<option value="' + esc(code) + '">' + (f ? f + ' ' : '') + esc(name) + '</option>';
      }).join('');
      row.innerHTML = '<div class="kst-cur"><span class="kst-cur-v"></span>' +
        '<select aria-label="' + esc(tx('cur', 'Currency')) + '">' + opts + '</select></div>';
      if (social) spot.insertBefore(row, social.nextSibling); else spot.appendChild(row);
      sel = row.querySelector('select');
      shown = row.querySelector('.kst-cur-v');
      sel.addEventListener('change', function () {
        var code = sel.value;
        var li = items().filter(function (l) { return codeOf(l) === code; })[0];
        /* the app listens on each choice itself; a click that does not
           travel up the page leaves the menu open */
        if (li) li.dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true }));
        setTimeout(paint, 60);
      });
      paint();
      /* opened again later: show what the prices are in now */
      if (nav && window.MutationObserver) {
        new MutationObserver(function () {
          if (nav.classList.contains('drawer--is-open')) paint();
        }).observe(nav, { attributes: true, attributeFilter: ['class'] });
      }
    }
 
    /* the app draws its button a moment after the page; wait for it */
    (function wait() {
      var list = items();
      if (list.length) { build(list); return; }
      if (++tries > 120) { root.classList.remove('kst-curm'); return; }
      setTimeout(wait, 250);
    })();
  })();
 
  /* =====================================================================
     SHOP IN MY SIZE (collection pages)
     ===================================================================== */
  if (CFG.mine && CFG.coll) (function () {
    var sv = SV(), k = KS();
    if (!sv || !k) return;
    var DATA = null, pending = null, bar = null, applyT = null;
    var S = { id: '', only: !!CFG.only && store('session', 'kst_only') === '1' };
 
    function people() { return sv.list(); }
    /* "your size" for Me, "Emma’s size" for everybody else */
    function isMe(p) { return /^(me|myself|my size|mine)$/i.test(p.name); }
    function whose(p) { return isMe(p) ? 'your' : esc(p.name) + '’s'; }
    /* a text about a person: for Me, "[name]’s size" reads "your size"
       and "for [name]" reads "for you" (also in texts saved earlier) */
    function aboutWho(tpl, p, map) {
      tpl = String(tpl).replace(/\[name\](’|')s\b/g, '[whose]');
      if (isMe(p)) tpl = tpl.replace(/\[name\]/g, 'you');
      map.whose = whose(p);
      map.name = esc(p.name);
      return fill(tpl, map);
    }
    function unitIn() { var l = k.recall ? (k.recall() || {}) : {}; return l.unit === 'in'; }
    function lenTxt(cm) { return unitIn() ? (cm / 2.54).toFixed(2) + ' in' : (Math.round(cm * 10) / 10).toFixed(1).replace(/\.0$/, '') + ' cm'; }
 
    /* whose size: the one picked last, else the first saved; "Nobody"
       sticks for this visit */
    function chooseStart() {
      var list = people();
      if (!list.length) { S.id = ''; return; }
      var kept = store('session', 'kst_mine');
      if (kept === 'off') { S.id = ''; return; }
      var picked = sv.pick ? sv.pick() : '';
      var ids = list.map(function (p) { return p.id; });
      S.id = ids.indexOf(kept) > -1 ? kept : ids.indexOf(picked) > -1 ? picked : ids[0];
    }
 
    function anchor() {
      var a = document.getElementById('CollectionAjaxResult');
      if (a) return a;
      var g = document.querySelector('.grid-product[data-product-handle]');
      return g ? (g.closest('.grid') || g.parentNode) : null;
    }
    /* the theme's Filter and Sort row: the bar goes inside it, as one panel */
    function panel() {
      return CFG.panel ? document.querySelector('#CollectionSection .collection-filter') : null;
    }
    function ensureBar() {
      var box = panel();
      if (bar && bar.isConnected && (!box || bar.parentNode === box)) return bar;
      var a = box ? null : anchor();
      if (!box && (!a || !a.parentNode)) return null;
      bar = bar || document.createElement('div');
      bar.className = 'kst-mine';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', tx('shop', 'Shop in the size of'));
      if (box) box.appendChild(bar);
      else a.parentNode.insertBefore(bar, a);
      return bar;
    }
    function markPanel(el) {
      var box = el.parentNode;
      if (box && box.classList && box.classList.contains('collection-filter')) box.classList.toggle('kst-panel', !el.hidden);
    }
 
    function paintBar() {
      var el = ensureBar();
      if (!el) return;
      var list = people();
      if (!list.length) { el.hidden = true; el.innerHTML = ''; markPanel(el); return; }
      el.hidden = false;
      markPanel(el);
      var chips = list.map(function (p) {
        var on = p.id === S.id;
        return '<button type="button" class="kst-pc' + (on ? ' is-on' : '') + '" data-kst-person="' + esc(p.id) + '" aria-pressed="' + on + '">' +
          I.user + '<b>' + esc(p.name) + '</b><span>' + esc(lenTxt(p.foot)) + '</span></button>';
      }).join('') +
        '<button type="button" class="kst-pc' + (S.id ? '' : ' is-on') + '" data-kst-person="" aria-pressed="' + !S.id + '">' + esc(tx('off', 'Nobody')) + '</button>';
      el.innerHTML = '<span class="kst-mlab">' + esc(tx('shop', 'Shop in the size of')) + '</span>' +
        '<div class="kst-mchips" role="group" aria-label="' + esc(tx('shop', 'Shop in the size of')) + '">' + chips + '</div>' +
        (CFG.only ? '<label class="kst-only' + (S.id ? '' : ' is-off') + '"><input type="checkbox" data-kst-only' + (S.only ? ' checked' : '') + (S.id ? '' : ' disabled') + '>' + esc(tx('only', 'In stock only')) + '</label>' : '') +
        '<p class="kst-mnote" aria-live="polite"></p>';
    }
 
    function prep(raw) {
      var p = norm(raw);
      return { p: p, chart: chartOf(p, null) };
    }
    function load() {
      if (DATA) return Promise.resolve(DATA);
      if (!pending) {
        pending = getJSON(ROOT + 'collections/' + encodeURIComponent(CFG.coll) + '/products.json?limit=250').then(function (d) {
          DATA = {};
          (d.products || []).forEach(function (raw) { DATA[raw.handle] = prep(raw); });
          return DATA;
        }, function () {
          DATA = {};
          return DATA;
        });
      }
      return pending;
    }
    /* a shoe on the page that the collection list did not have (another
       page of a big collection, a filter): ask for it on its own */
    var asking = {};
    function askFor(handle) {
      if (asking[handle]) return;
      asking[handle] = true;
      getJSON(ROOT + 'products/' + encodeURIComponent(handle) + '.js').then(function (raw) {
        DATA[handle] = prep(raw);
        applySoon();
      }, function () { DATA[handle] = { p: null, chart: null }; });
    }
 
    function apply() {
      var who = S.id ? sv.get(S.id) : null;
      var cards = $$('.grid-product[data-product-handle]');
      var shoes = 0, inStock = 0;
      cards.forEach(function (card) {
        var badge = card.querySelector('.kst-badge');
        card.classList.remove('kst-hide');
        if (!who || !DATA) { if (badge) badge.parentNode.removeChild(badge); return; }
        var handle = card.getAttribute('data-product-handle');
        var info = DATA[handle];
        if (!info) { askFor(handle); return; }
        if (!info.chart) { if (badge) badge.parentNode.removeChild(badge); return; }
        shoes++;
        var r = k.sizeFor(info.chart, who.foot, { fit: who.fit, socks: who.socks });
        var cls, html;
        if (!r || !r.bestAny) {
          cls = 'is-none';
          html = aboutWho(tx('none', 'No size for [name]'), who, {});
        } else if (r.bestAny.inStock) {
          cls = 'is-in';
          inStock++;
          html = fill(tx('in', '[size] in stock'), { size: 'US ' + esc(r.bestAny.us), name: esc(who.name) });
        } else {
          cls = 'is-out';
          html = fill(tx('sold', '[size] sold out'), { size: 'US ' + esc(r.bestAny.us), name: esc(who.name) });
        }
        if (!badge) {
          badge = document.createElement('span');
          var host = card.querySelector('.grid-product__image-mask') || card.querySelector('.grid-product__content') || card;
          host.appendChild(badge);
        }
        if (badge.getAttribute('data-k') !== cls + html) {
          badge.setAttribute('data-k', cls + html);
          badge.className = 'kst-badge ' + cls;
          badge.innerHTML = '<i></i>' + html;
        }
        if (S.only && cls !== 'is-in') card.classList.add('kst-hide');
      });
      /* how many of the whole collection (every page) fit and are in stock */
      /* Which shoes the count is about: every shoe on the page when all
         of them are here (one page, or In stock only brought them all);
         otherwise the whole collection, unless a filter is on, because
         the collection list does not know the theme's filters */
      var all = 0, made = 0, fits = 0, pgEl = pager(), handles = null;
      if (!pgEl || pgEl.hidden) handles = cards.map(function (c) { return c.getAttribute('data-product-handle'); });
      else if (!/[?&]filter\./.test(location.search)) handles = DATA ? Object.keys(DATA) : null;
      if (who && DATA && handles) {
        handles.forEach(function (h) {
          var info = DATA[h];
          if (!info || !info.chart) return;
          all++;
          var r = k.sizeFor(info.chart, who.foot, { fit: who.fit, socks: who.socks });
          if (r && r.bestAny) made++;
          if (r && r.bestAny && r.bestAny.inStock) fits++;
        });
      }
      var note = bar && bar.querySelector('.kst-mnote');
      if (note) {
        note.innerHTML = !who || !all || !handles ? ''
          /* no model here is made that long or that short */
          : !made ? aboutWho(tx('nofit', 'None of these shoes come in [whose] size.'), who, {})
          : S.only && !fits ? aboutWho(tx('empty', 'Nothing here is in stock in [whose] size right now.'), who, {})
          : aboutWho(tx('count', '[in] of [all] shoes here are in stock in [whose] size.'), who, { 'in': '<b>' + fits + '</b>', all: String(all) });
      }
      /* In stock only looks at every page of the collection, not only
         the one on screen: the other pages are brought onto this one */
      if (who && S.only) loadAll(); else unloadAll();
    }
 
    /* ---------- In stock only: every page on one ---------- */
    var MORE = { key: '', busy: false };
    function pager() {
      return document.querySelector('#CollectionAjaxResult .pagination') || document.querySelector('.pagination');
    }
    function pageOf(url) { var m = /[?&]page=(\d+)/.exec(url || ''); return m ? +m[1] : 1; }
    function loadAll() {
      var pg = pager();
      if (!pg || MORE.busy) return;
      var links = Array.prototype.map.call(pg.querySelectorAll('a[href*="page="]'), function (a) { return a.getAttribute('href'); });
      if (!links.length) return;
      var cur = pageOf(location.search), last = 1;
      links.forEach(function (u) { last = Math.max(last, pageOf(u)); });
      var key = links[0].replace(/([?&])page=\d+/, '$1') + '|' + cur + '|' + last;
      if (MORE.key === key) return;
      MORE.key = key;
      MORE.busy = true;
      if (bar) bar.setAttribute('aria-busy', 'true');
      var urls = [];
      for (var n = 1; n <= last; n++) if (n !== cur) urls.push({ n: n, u: links[0].replace(/([?&])page=\d+/, '$1page=' + n) });
      Promise.all(urls.map(function (x) {
        return fetch(x.u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }, function () { return ''; })
          .then(function (html) { return { n: x.n, html: html }; });
      })).then(function (pages) {
        MORE.busy = false;
        if (bar) bar.removeAttribute('aria-busy');
        var first = document.querySelector('.grid-product[data-product-handle]');
        if (!first || !pager()) return;
        var grid = first.parentNode, have = {};
        $$('.grid-product[data-product-handle]').forEach(function (c) { have[c.getAttribute('data-product-handle')] = 1; });
        var parser = new DOMParser();
        pages.sort(function (a, b) { return a.n - b.n; }).forEach(function (pgx) {
          if (!pgx.html) return;
          var doc = parser.parseFromString(pgx.html, 'text/html');
          Array.prototype.forEach.call(doc.querySelectorAll('.grid-product[data-product-handle]'), function (c) {
            var h = c.getAttribute('data-product-handle');
            if (have[h]) return;
            have[h] = 1;
            var card = document.importNode(c, true);
            card.setAttribute('data-kst-more', String(pgx.n));
            /* the quick view needs a window the theme only makes for the
               cards it drew itself; the card still opens the product */
            Array.prototype.forEach.call(card.querySelectorAll('.quick-product__btn'), function (b) { b.parentNode.removeChild(b); });
            /* shown right away, without the theme's scroll animation */
            [card].concat(Array.prototype.slice.call(card.querySelectorAll('[data-aos]'))).forEach(function (el) {
              if (el.hasAttribute && el.hasAttribute('data-aos')) el.classList.add('aos-init', 'aos-animate');
            });
            if (pgx.n < cur) grid.insertBefore(card, first); else grid.appendChild(card);
          });
        });
        var p = pager();
        if (p) { p.setAttribute('data-kst-hid', ''); p.hidden = true; }
        var bc = window.baCurr;
        if (bc && typeof bc.refreshConversion === 'function') { try { bc.refreshConversion(); } catch (e) {} }
        applySoon();
      });
    }
    function unloadAll() {
      var more = $$('[data-kst-more]');
      more.forEach(function (c) { c.parentNode.removeChild(c); });
      $$('[data-kst-hid]').forEach(function (p) { p.hidden = false; p.removeAttribute('data-kst-hid'); });
      MORE.key = '';
    }
    function applySoon() { clearTimeout(applyT); applyT = setTimeout(apply, 60); }
 
    function refresh() {
      paintBar();
      if (S.id) load().then(apply); else apply();
    }
 
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-kst-person]') : null;
      if (!b || !bar || !bar.contains(b)) return;
      e.preventDefault();
      var id = b.getAttribute('data-kst-person');
      S.id = id;
      store('session', 'kst_mine', id || 'off');
      /* the same person is then ready on the product page */
      if (id && sv.pick) sv.pick(id);
      track('ks_shop_my_size', { on: !!id });
      /* drawn again after this click is over, like the cart editor */
      setTimeout(function () {
        refresh();
        var again = bar.querySelector('[data-kst-person="' + (id || '').replace(/["\\]/g, '\\$&') + '"]');
        if (again) again.focus();
      }, 0);
    });
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-kst-only')) return;
      S.only = !!e.target.checked;
      store('session', 'kst_only', S.only ? '1' : null);
      apply();
    });
    /* saved, renamed or deleted on another page or tab */
    document.addEventListener('ks:sizes', function () { chooseStart(); refresh(); });
 
    /* filters and sorting build the product grid again */
    var sec = document.getElementById('CollectionSection') || document.querySelector('[data-section-type="collection-template"]');
    if (sec && window.MutationObserver) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var n = list[i].addedNodes;
          for (var j = 0; j < n.length; j++) {
            var el = n[j];
            /* our own bar and badges changing is not a new grid */
            if (el.nodeType !== 1 || el === bar || (bar && bar.contains(el))) continue;
            if (el.closest && el.closest('.kst-badge')) continue;
            if (bar && !bar.isConnected) paintBar();
            applySoon();
            return;
          }
        }
      }).observe(sec, { childList: true, subtree: true });
    }
 
    chooseStart();
    refresh();
  })();
})();
